module.exports = __webpack_public_path__ + "static/media/no_img_player_detail.25c35dd2.png";